import React, { useState } from "react";

import { Button, Col, Form, Row, ToggleButton } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import { Controller, useFormContext } from "react-hook-form";

import fr from "date-fns/locale/fr";

import "react-datepicker/dist/react-datepicker.css";
import { DateTime } from "luxon";
import AsyncSelect from "react-select/async";

import Axios from "../../../../_helpers/axiosHelper";
import edit from "../../../../assets/svg/edit.svg";
import { FormValues } from "../../../../common/type/sharedTypes";
import { IKeysInfos } from "../../reducers";


registerLocale("fr", fr);

interface IProps {
  isDiag: boolean;
  keysInfos: IKeysInfos;
  setKeysInfos: React.Dispatch<React.SetStateAction<IKeysInfos>>;
  showAndEdit: boolean | undefined;
}

export const isValid = (_props: IProps) => {};

const KeysInfos = ({
  keysInfos,
  setKeysInfos,
  showAndEdit,
  isDiag,
}: IProps) => {
  const { setValue, control, register } = useFormContext<FormValues>();
  const [editMode, setEditMode] = useState(false);

  const handleChanges = () => {
    //TODO implement
    setEditMode(false);
  };

  const changeKeysat_partner = (e: any) => {
    setKeysInfos({ ...keysInfos, at_partner: !!e.target.checked });
  };

  const changeMoment = (moment: boolean) => {
    setValue("keyForm.moment", moment);
    setKeysInfos({ ...keysInfos, moment });
  };
  const loadOptions = (
    inputText: string,
    callback: (options: any) => void,
  ): void => {
    Axios.get(`search/?q=${inputText.replace(/ /g, "+")}`).then(
      (response: any) => {
        const data: any = response.data.features;
        callback(
          data.map((result: any) => {
            return {
              value: {
                city: result.properties.city,
                address: result.properties.address,
                zip: result.properties.postcode,
                longitudeX: result.geometry.coordinates[0].toString(),
                latitudeY: result.geometry.coordinates[1].toString(),
              },
              label: result.properties.label,
            };
          }),
        );
      },
    );
  };
  const checkPartner = () => {
    if ("at_partner" in keysInfos) {
      return keysInfos.at_partner;
    } else {
      if (isDiag) {
        return true;
      }
    }
    return false;
  };

  return (
    <div>
      <div className="d-flex flex-row justify-content-between align-middle align-items-center gap-4 flex-wrap ">
        <h2 className="order-title">Les clés</h2>
        {showAndEdit !== undefined && (
          <>
            {editMode ? (
              <Button
                variant="primary"
                role="button"
                onClick={() => handleChanges()}
              >
                Enregistrer les modifications
              </Button>
            ) : (
              <button
                className="btn btn-actions btn-edit-order cursor-pointer"
                onClick={() => setEditMode(true)}
              >
                <img
                  src={edit}
                  alt="edit"
                  style={{ width: "12px", height: "12px" }}
                />
              </button>
            )}
          </>
        )}
      </div>
      <p className="p-order">
        Indiquez les informations pour récupérer les clés
      </p>

      <Row className="mt-3">
        <Form.Group controlId="checkbox-keys">
          <Form.Check
            disabled={showAndEdit === undefined ? false : !editMode}
            className="radio-order"
            {...register("keyForm.isEdit")}
            type="checkbox"
            label="Récupérer les clés chez un prestataire ?"
            checked={checkPartner()}
            onChange={changeKeysat_partner}
          />
        </Form.Group>
      </Row>
      <Row className="mt-1">
        {checkPartner() && (
          <>
            <Col
              xs={12}
              md={4}
              className="d-flex flex-column justify-content-between mt-3"
            >
              <label className="w-100 add-prop-label ms-2">Société</label>
              <input
                disabled={showAndEdit === undefined ? false : !editMode}
                className="w-100 add-prop-input"
                type="text"
                {...register("keyForm.societyName")}
              />
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex flex-column justify-content-between mt-3"
            >
              <label className="w-100 add-prop-label ms-2">
                Nom du contact
              </label>
              <input
                disabled={showAndEdit === undefined ? false : !editMode}
                className="w-100 add-prop-input"
                type="text"
                {...register("keyForm.contactName")}
              />
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex flex-column justify-content-between mt-3"
            >
              <label className="w-100 add-prop-label ms-2">
                Numéro de téléphone
              </label>
              <input
                disabled={showAndEdit === undefined ? false : !editMode}
                className="w-100 add-prop-input"
                type="tel"
                {...register("keyForm.phone")}
              />
            </Col>
            <Col
              xs={12}
              md={4}
              className="d-flex flex-column justify-content-between mt-3"
            >
              <label className="w-100 add-prop-label ms-2">Adresse email</label>
              <input
                disabled={showAndEdit === undefined ? false : !editMode}
                className="w-100 add-prop-input"
                type="email"
                {...register("keyForm.email")}
              />
            </Col>

            <Col
              xs={12}
              md={4}
              className="d-flex flex-column justify-content-between mt-3"
            >
              <label className="w-100 add-prop-label ms-2 mt-3">
                Adresse postale
              </label>
              <Controller
                control={control}
                name="keyForm.address"
                render={(dateTime) => (
                  <AsyncSelect
                    onChange={(date) => dateTime.field.onChange(date)}
                    cacheOptions
                    loadOptions={loadOptions}
                    placeholder={""}
                    noOptionsMessage={() => "Aucune adresse correspondante"}
                    loadingMessage={() => "Recherche..."}
                  />
                )}
              />
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col>
          <label className="w-100 add-prop-label ms-2 mt-3">
            Informations complémentaires
          </label>
          <textarea
            //disabled={!!showAndEdit || !editMode}
            className="w-100 add-prop-input add-prop-textarea"
            placeholder="Horaires de l’agence, disponibles à l’accueil..."
            {...register("keyForm.furtherInformation")}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={6}>
          <label className="w-100 add-prop-label ms-2">
            Disponibilité des clés
          </label>
          <Controller
            control={control}
            name="keyForm.dateRecup"
            defaultValue={DateTime.now().toISO()}
            render={(dateTime) => (
              <DatePicker
                disabled={showAndEdit === undefined ? false : !editMode}
                className="w-100 add-prop-input date-select"
                dateFormat="dd/MM/yyyy"
                locale="fr"
                selected={
                  dateTime.field.value
                    ? new Date(dateTime.field.value)
                    : new Date()
                }
                onChange={(date) => {
                  dateTime.field.onChange(
                    (date ? DateTime.fromJSDate(date) : DateTime.now()).toISO(),
                  );
                }}
                formatWeekDay={(nameOfDay) =>
                  nameOfDay.toString().toUpperCase().substr(0, 1)
                }
              />
            )}
          />

          <div className="d-flex justify-content-center my-md-4">
            <ToggleButton
              disabled={showAndEdit === undefined ? false : !editMode}
              className="btn-order mb-1 me-2"
              checked={keysInfos.moment}
              type="radio"
              value="morning"
              onClick={() => changeMoment(true)}
            >
              Matin
            </ToggleButton>
            <ToggleButton
              disabled={showAndEdit === undefined ? false : !editMode}
              className="btn-order mb-1 ms-2"
              checked={!keysInfos.moment}
              type="radio"
              value="afternoon"
              onClick={() => changeMoment(false)}
            >
              Après-midi
            </ToggleButton>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default KeysInfos;
